<template>
  <v-container>
    <v-card
      :loading="false"
    >
      <v-overlay
        :absolute="true"
        :value="isComponentLoading"
      >
        <v-progress-circular indeterminate size="24"></v-progress-circular>
      </v-overlay>
      <v-row class="pa-3">
        <v-col cols="12" md="12">
          <v-text-field
            v-model="searchParams.search_contact"
            :hint="$t('hints.searchByPhone')"
            persistent-hint
            single-line
            :loading="false"
          />
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import searchTextFilter from '@/mixins/filters/searchTextFilter';
import isComponentLoading from '@/mixins/isComponentLoading';
/* components */

export default {
  name: 'FilterTelegramBot',
  mixins: [
    isComponentLoading,
    searchTextFilter,
  ],
  components: {
  },
  props: {
    defaultSearchParams: {
      type: Object,
      default: () => ({
        search_contact: '',
        region: null,
      }),
    },
  },
  data() {
    return {
      searchParams: {},
    };
  },
  mounted() {
    this.searchParams = {
      search_contact: this.defaultSearchParams.search_contact,
    };
  },
  computed: {
    account() {
      return this.$store.getters['account/account'];
    },
  },
  watch: {
    searchParams: {
      handler(newVal) {
        this.$emit('filtering', newVal);
      },
      deep: true,
    },
  },
  methods: {

  },
};
</script>

<style scoped>

</style>
